import { Component } from '@angular/core';

@Component({
  selector: 'app-settings-email-config-form',
  standalone: true,
  imports: [],
  templateUrl: './app-settings-email-config-form.component.html',
  styleUrl: './app-settings-email-config-form.component.css'
})
export class AppSettingsEmailConfigFormComponent {

}
